import styled from 'styled-components';

import { colors } from '../../constants';

export const SubmitButton = styled.button.attrs(() => ({
    type: 'submit',
}))`
    appearance: none;
    display: block;
    padding: 0 70px;
    height: 56px;
    margin-top: 60px;
    font-family: inherit;
    text-align: center;
    color: ${colors.white};
    background: ${colors.black};
    border: 0;
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s linear;

    &:focus {
        outline: 0;
    }

    &:disabled {
        background: ${colors.greyLight};
    }
`;
